module.exports = __webpack_public_path__ + "img/p1-desc@2x.e2ea9012.jpg";